import { render, staticRenderFns } from "./LatestClientEnquiries.vue?vue&type=template&id=6e510d4f&scoped=true"
import script from "./LatestClientEnquiries.vue?vue&type=script&lang=js"
export * from "./LatestClientEnquiries.vue?vue&type=script&lang=js"
import style0 from "./LatestClientEnquiries.vue?vue&type=style&index=0&id=6e510d4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e510d4f",
  null
  
)

export default component.exports